import { InputSize } from '../../../../../utils/shared/input-size/input-size.enum';

export const sizeSelectOptions = [
  {
    key: 'Default',
    value: InputSize.Default
  },
  {
    key: 'Small',
    value: InputSize.Small
  },
  {
    key: 'Large',
    value: InputSize.Large
  }
];
